import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class SignInRequest {
  @jsonMember(String)
  public username!: string;

  @jsonMember(String)
  public password!: string;

  @jsonMember(Boolean)
  public rememberMe!: boolean;

  public constructor(
    usernameOrEmail: string,
    password: string,
    rememberMe: boolean,
  ) {
    this.username = usernameOrEmail;
    this.password = password;
    this.rememberMe = rememberMe;
  }
}
